/** Read-back is about a main-portal record, never pricing access or a working password. */
export function verifiedTeamMember(response, expected) {
  if (response?.ok !== true || !Array.isArray(response.members)) {
    throw new Error('Could not verify the main portal server roster. Check the roster before retrying creation.')
  }
  const matches = response.members.filter((member) => member.id === expected.id)
  const member = matches[0]
  if (matches.length !== 1 || member.name !== expected.name ||
      (member.email || '') !== expected.email || member.role !== expected.role || member.active !== true) {
    throw new Error('The main portal account could not be verified against the requested details. Review the server roster before creating or changing this account.')
  }
  return member
}

/** Only explicit client rejections are safe to correct and resubmit automatically. */
export function creationWasRejected(error) {
  return [400, 401, 403, 404, 409, 422, 429].includes(error?.status)
}
